import { CSVEntity } from 'shared'
import CIMSTable from 'components/CIMSTable'
import { AdvancementModal } from './components/AdvancementModal'
import { useDesignSubmittalLogContext } from '../../DesignSubmittalLogContext'
import { useColumns } from './hooks/useColumns'
import { usePayItemsOptions } from './hooks/usePayItemsOptions'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useCustomRowOptions } from './hooks/useCustomRowOptions'
import { useRestoreOptions } from './hooks/useRestoreOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import RevertModal from './components/RevertModal'
import { CreateDesignSubmittalModal } from './hooks/useCreateOptions/components/CreateDesignSubmittalModal'

const DesignSubmittalLogTable: React.FC = () => {
  const {
    payItemGlobalId,
    records,
    refetch,
    fetching,
    RepairModal,
    createModal: { toggle: toggleCreateModal, ...createModal },
  } = useDesignSubmittalLogContext()
  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={useColumns()}
      actions={{
        header: {
          csv: !!payItemGlobalId ? undefined : CSVEntity.DesignSubmittal,
          create: useCreateOptions(),
          onReload: refetch,
          payItems: usePayItemsOptions(),
          deepLinkKey: 'id',
        },
        row: {
          edit: useEditOptions(),
          remove: useRemoveOptions(),
          restore: useRestoreOptions(),
          custom: useCustomRowOptions(),
        },
      }}
      expand={useExpandOptions()}
    >
      <CreateDesignSubmittalModal
        onClose={() => {
          toggleCreateModal(null)
          refetch()
        }}
        {...createModal}
      />
      <AdvancementModal />
      <RevertModal />
      {RepairModal}
    </CIMSTable>
  )
}

export default DesignSubmittalLogTable
